exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-cv-card__workflow-application-stage-container{display:relative}.upload-cv-card__workflow-application-stage-container:not(:last-child){margin-bottom:29px}.upload-cv-card__workflow-application-stage-container:last-child .upload-cv-card__icon-container:after{display:none}.upload-cv-card__icon-container{position:relative}.upload-cv-card__icon-container:after{content:\"\";width:2px;background-color:#d8e4f1;height:23px;position:absolute;left:50%;transform:translateX(-50%);top:29px}", ""]);

// exports
